const SCALAR_SCALE = 1_000_000_000_000;

export function formatMetric(value: string | bigint, metric: number): string {
  const numeric = Number(value) / SCALAR_SCALE;
  const percent = numeric * 100;
  if (metric === 0) {
    if (percent < 0) return `−${Math.abs(percent).toFixed(4)}%`;
    return `${percent > 0 ? "+" : ""}${percent.toFixed(4)}%`;
  }
  return `${percent.toFixed(1)}%`;
}

export function formatCollateral(value: string | bigint): string {
  return (Number(value) / 1_000_000).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

export function impliedProbability(
  longOutcomePerCollateral: string | bigint | undefined,
  shortOutcomePerCollateral: string | bigint | undefined
): number {
  const longOutput = Number(longOutcomePerCollateral ?? 0);
  const shortOutput = Number(shortOutcomePerCollateral ?? 0);
  if (longOutput <= 0 || shortOutput <= 0) return 0.5;
  const longPrice = 1 / longOutput;
  const shortPrice = 1 / shortOutput;
  return longPrice / (longPrice + shortPrice);
}

export function slippageFloor(value: bigint, bps: number): bigint {
  return (value * BigInt(10_000 - bps)) / 10_000n;
}

export function shortenAddress(address: string): string {
  return `${address.slice(0, 6)}…${address.slice(-4)}`;
}

export function formatDate(timestamp: number): string {
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit"
  }).format(new Date(timestamp * 1_000));
}
